<template>
    <div id="app" class="page">
        <SpriteMap />
        <Header />
        <div class="page__content" :class="{'page__content__mobile': isTabletViewport}">
            <LazyLoadedImage
                v-if="$route.path === '/' && !isOrderProcessOngoing && isTabletViewport"
                src="https://content.murtfeldt-as.de/fileadmin/user_upload/infobanner_mobile.jpg"
                alt="Mobile Hero"
            ></LazyLoadedImage>
            <transition name="expand">
                <OrderProcess
                    v-show="
                        hasOrderProcess &&
                        isOrderProcessOngoing &&
                        isCheckoutOpen
                    "
                ></OrderProcess>
            </transition>
            <transition name="fade">
                <router-view />
            </transition>
        </div>
        <Environment />
        <Footer />
        <Snackbar />
        <!--
        <SnackbarInfo />
        -->
        <CookieConsent />
        <b-modal v-model="welcomeJomatik" :full-screen="true">
            <welcome-jomatik />
        </b-modal>
        <b-modal v-model="showOneMurtfeldtNotification">
            <template #default="props">
                <one-murtfeldt-notification @close="props.close" />
            </template>
        </b-modal>

    </div>
</template>

<style lang="scss">
@import 'styles/_all.scss';
@import '~bulma';
@import '~buefy/src/scss/buefy';

.page__content__mobile {
    margin-top: calc(3rem - 1px);
}
</style>
<script>
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import { mapGetters } from 'vuex';
import { viewports } from './store/constants/viewports';
import { orderProcess } from './store/constants/order-process';

import OrderProcess from './components/checkout/OrderProcess';
import SpriteMap from './components/svg/SpriteMap';
import Snackbar from './components/shared/Snackbar';
import SnackbarInfo from './components/shared/SnackbarInfo';
import CookieConsent from './components/shared/CookieConsent';
import Environment from './components/shared/Environment';
import { $axios } from './store/modules/axios-instance';
import WelcomeJomatik from './components/global/WelcomeJomatik';
import OneMurtfeldtNotification from './components/global/OneMurtfeldtNotification';
import LazyLoadedImage from './components/shared/LazyLoadedImage';

export default {
    components: {
        OneMurtfeldtNotification,
        WelcomeJomatik,
        CookieConsent,
        Snackbar,
        SnackbarInfo,
        SpriteMap,
        OrderProcess,
        Footer,
        Header,
        Environment,
        LazyLoadedImage
    },
    data() {
        return {
            welcomeJomatik: false,
            showOneMurtfeldtNotification: false,
            viewports,
        };
    },
    computed: {
        ...mapGetters([
            'currentViewport',
            'currentOrderProcessStep',
            'isCheckoutOpen',
        ]),
        hasOrderProcess() {
            switch (this.currentViewport) {
                case viewports.MOBILE.name:
                case viewports.TABLET.name:
                    return true;
                default:
                    return false;
            }
        },
        isOrderProcessOngoing() {
            return (
                this.currentOrderProcessStep !==
                    orderProcess.STEPS.NO_ORDER_ONGOING &&
                this.currentOrderProcessStep !==
                    orderProcess.STEPS.ORDER_COMPLETED
            );
        },
        isTabletViewport() {
            return [viewports.MOBILE.name, viewports.TABLET.name].includes(
                this.currentViewport
            )
        }
    },
    methods: {
        setScreenSize() {
            let screenSize = {
                width: window.innerWidth,
                height: window.innerHeight,
            };

            this.$store.dispatch('setScreenSize', screenSize);
        },
        attachEventListeners() {
            window.addEventListener('resize', this.setScreenSize);
        },
        removeEventListeners() {
            window.removeEventListener('resize', this.setScreenSize);
        },
    },
    created() {
        let locale = 'de-DE';
        let header = 'DE';
        switch (this.$route.params.lang) {
            case 'en':
                locale = 'en-US';
                header = 'GB';
        }
        this.$i18n.locale = locale;
        $axios.defaults.headers = {
            ...$axios.defaults.headers,
            'mas-language-key': header,
        };
        this.attachEventListeners();
    },
    mounted() {
        if (this.$route.hash === '#welcome-jomatik') {
            this.welcomeJomatik = true;
        }

        // if (this.$route.name === 'Home') {
        //     this.showOneMurtfeldtNotification = true;
        // }

        this.setScreenSize();
        this.$store.dispatch('createCart');
        this.$store.dispatch('checkAuth');
        this.$store.dispatch('fetchItemsFromLocalStorage');
        this.$store.dispatch('fetchShippingCountries');
        this.$store.dispatch('reloadDiscount');
    },
    destroyed() {
        this.removeEventListeners();
    },
};
</script>
